/* @jsxImportSource react */

import { cn } from '@packages/shared/src/utils/cn/cn';

import { RatingDisplay, type RatingDisplayProps } from '../RatingDisplay/RatingDisplay';

export const ProductCardV2Rating = ({
  id,
  className,
  ...ratingDisplayProps
}: Omit<RatingDisplayProps, 'id'> & { id: string; className?: string }) => (
  <div
    id={`product-${id}-rating`}
    className={cn('product-card-rating mx-2 mt-1 [grid-area:11/2/span_1/span_1]', className)}
  >
    <RatingDisplay {...ratingDisplayProps} />
  </div>
);
